import { useRef, useState } from "react";
import { ApiFehler, fehlerText } from "../api/client";
import { useAufgabeAnlegen } from "../api/abfragen";
import { Feld } from "../design/Feld";
import { Fehlertext } from "../design/Leer";
import { Sheet } from "../design/Sheet";
import { useSichern } from "../design/sichern";

/** Blatt „Neue Aufgabe“ der Startseite und der Seite „Aufgaben“ (W82 Web-7, Nachzügler 2: aus Posteingang.tsx hierher
 *  verschoben, unverändert). */
export function NeueAufgabe(props: { offen: boolean; onSchliessen: () => void }) {
  const [titel, setTitel] = useState("");
  const [faellig, setFaellig] = useState("");
  const anlegen = useAufgabeAnlegen();
  // D-089 (W51): bis zur Antwort schliesst nichts das Blatt, „Sichern“ sendet einmal
  const sicherung = useSichern(props.offen);
  // W82 Web-5h1 (Punkt 7, Sonde): zwei Klicks im selben Bild sandten zwei POST (`laeuft` sperrt den Knopf erst mit dem nächsten
  // Rendern); ein Tipp, eine Anfrage wie `FristNeuBlatt.tsx`
  const gesendet = useRef(false);
  function sichern() {
    if (gesendet.current || sicherung.laeuft) return;
    gesendet.current = true;
    // BS30: nach SICHERN_GRENZE_MS ohne Antwort bricht `useSichern` ab, das Blatt zeigt den Netz-Satz
    sicherung.sichern((signal) =>
      anlegen.mutateAsync(
        { titel: titel.trim(), faellig: faellig || null, signal },
        {
          onSuccess: () => {
            setTitel("");
            setFaellig("");
            props.onSchliessen();
          },
          onSettled: () => {
            gesendet.current = false;
          },
        },
      ),
    );
  }
  return (
    <Sheet
      offen={props.offen}
      onSchliessen={props.onSchliessen}
      gesperrt={sicherung.laeuft}
      titel="Neue Aufgabe"
      rechts={
        <button type="button" disabled={!titel.trim() || sicherung.laeuft} onClick={sichern} className="t-headline min-h-(--touch) text-pg-accent-text disabled:text-pg-text-3">
          Sichern
        </button>
      }
    >
      <ul className="gruppe mt-4 overflow-clip rounded-group bg-pg-surface">
        <Feld label="Was ist zu tun?" value={titel} onChange={(e) => setTitel(e.target.value)} maxLength={300} autoFocus />
        <Feld label="Fällig am (optional)" type="date" value={faellig} onChange={(e) => setFaellig(e.target.value)} />
      </ul>
      {anlegen.error && <Fehlertext fehler={anlegen.error instanceof ApiFehler ? anlegen.error : new Error(fehlerText(anlegen.error))} />}
    </Sheet>
  );
}